module.exports = __webpack_public_path__ + "img/cir.87d70c9e.png";